export default __webpack_public_path__ + "static/media/roadmap3.3e00072a.png";